module.exports = __webpack_public_path__ + "static/media/206B-1206B.87d30759.png";